import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 3a1 1 0 0 1 0 2h-16a1 1 0 1 1 0 -2z","key":"svg-0"}],["path",{"d":"M13 7a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-1"}]]

const IconLayoutAlignTopFilled = createReactComponent('filled', 'layout-align-top-filled', 'LayoutAlignTopFilled', __iconNode);

export default IconLayoutAlignTopFilled;